import * as Yup from 'yup';

export const mainSchema = Yup.object().shape({
  operationType: Yup.array().min(1, 'Selecciona una o más operaciones para continuar.'),
  propertyType: Yup.string().required('Selecciona un inmueble para continuar.'),
  operationAndPropertyEmpty: Yup.string().test(
    'both-fields-required',
    'Selecciona una o más operaciones y un inmueble para continuar.',
    function() {
      const { operationType, propertyType } = this.parent;
      // Devuelve true si ambos campos están vacíos (es decir, hay un error)
      return !(operationType.length === 0 && !propertyType);
    }
  )
});
